import { Checkbox, Table, TableBody, TableCell, TableFooter, TableHead, TableRow } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { IGridcolumn } from "./interface/column.interface";
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import Pagination from '@mui/material/Pagination';
import { set } from "lodash";

export interface IProps {
    columns: IGridcolumn[];
    data: any;
    selection?: boolean;
    selectionChanged?: (id: string[]) => void;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC' | '';
    sortChanged?: (column: string, direction: string) => void;
    pageChanged?: (page: number) => void;
    totalPages?: number;
    currentPage?: number;
}
export const TestResultStatusGrid = ({
    columns = [],
    data = [],
    selection = false,
    selectionChanged,
    sortChanged,
    sortBy = '',
    sortDirection = 'ASC',
    totalPages = 0,
    pageChanged,
    currentPage = 1,
}: IProps) => {

    const [order, setOrder] = useState<string>('');
    const [sort, setSort] = useState<string>('');
    const [direction, setDirection] = useState<'ASC' | 'DESC' | ''>('ASC');

    const [selected, setSelected] = useState<string[]>([]);
    const [allSelected, setAllSelected] = useState<boolean>(false);

    const RenderItem = ({ col = null as unknown as IGridcolumn, data = {} }) => {
        const Component = col?.redner;

        return (
            <Component  {...data} />
        )
    }

    const updateSort = (col: IGridcolumn) => () => {
        if (col.sortable && sortChanged) {
            if (sort === col.fieldName) {
                sortChanged(col.fieldName, direction === 'ASC' ? 'DESC' : 'ASC');
            } else {
                sortChanged(col.fieldName, 'ASC');
            }
            setSort(col.fieldName);

        }
    }

    const key = useMemo(() => columns.find(c => c.key)?.fieldName || 'id', [columns]);

    const checkChanged = (id: string) => (e: any) => {
        if (e.target.checked) {
            setSelected(selected.concat(id))
        } else {
            setSelected(selected.filter(s => s !== id));
        }
        
    }

    const checkAllTestResult = () => {
        if(!allSelected){
            const allResultId = data.map((result: any) => result.id);
            setSelected(allResultId)
        } else {
            setSelected([]);
        }
    }

    const onPageChanged = (e: any, page: number) => {
        pageChanged && pageChanged(page)
    }

    useEffect(() => {
        setOrder(sortBy.substring(1));
        setDirection(sortBy.charAt(0) === '-' ? 'DESC' : 'ASC');
    }, [sortBy, sortDirection])


    useEffect(() => {
        setAllSelected(selected.length === data.length && data.length > 0);
        selectionChanged && selectionChanged(selected);
    }, [selected,selectionChanged])

    return (
        <Table>
            <TableHead>
                <TableRow>
                    {selection && (
                        <TableCell width={'3%'}>
                            <div style={{display: 'flex'}}>
                                <Checkbox color="primary" onChange={checkAllTestResult} checked={allSelected}/>
                                <div style={{display: 'flex', alignItems: 'center'}}>Select</div>
                            </div>
                            
                        </TableCell>
                    )}
                    {columns.map((col, colIndex) => (
                        <TableCell
                            width={col.width || ''}
                            key={`col_${colIndex}_${col.fieldName ?? col.caption ?? 'col'}`}
                            style={{
                                textAlign: col?.caption === "ACTION" ? 'center' : 'left'
                            }}
                        >
                            <div onClick={updateSort(col)} className={`${col?.caption === 'ACTION' ? '' : 'flex-center'} ${col.sortable ? 'pointer' : ''}`}>
                                {col.caption}

                                {col.fieldName === order && (
                                    direction === 'ASC' ?
                                        <ArrowDropUpOutlinedIcon />
                                        :
                                        <ArrowDropDownOutlinedIcon />
                                )}
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>

            <TableBody>
                {data.map((row: any, index: number) => (
                    <TableRow key={`row_${index}`}>
                        {selection && (
                            <TableCell>
                                <Checkbox color="primary" onChange={checkChanged(row[key])} checked={selected.indexOf(row[key]) !== -1} />
                            </TableCell>
                        )}
                        {columns.map((col, colIndex) => (
                            col.redner ?
                            <TableCell
                            key={`col_${index}_${colIndex}_${col.fieldName ?? col.caption ?? 'col'}`}
                            style={{
                                textAlign: col?.caption === "ACTION" ? 'center' : 'left'
                            }}
                            >
                                <RenderItem col={col} data={row} />
                                </TableCell> :
                                <TableCell
                                key={`col_${index}_${colIndex}_${col.fieldName ?? col.caption ?? 'col'}`}>
                                    {row[col.fieldName]}
                                    </TableCell>
                        ))}
                    </TableRow>
                ))}
                {data?.length < 10 && (
                    Array.from(new Array(10 - data.length)).map((_, index) => (
                        <TableRow key={`extra_row_${index}`}>
                            <TableCell></TableCell>
                        </TableRow>
                    ))
                )}
            </TableBody>

            {totalPages>=0 && (
                <TableFooter >
                    <tr>
                        <td colSpan={columns.length + (selected ? 1 : 0)}>
                            <Pagination page={currentPage} onChange={onPageChanged} count={totalPages} showFirstButton showLastButton />
                        </td>
                    </tr>
                </TableFooter>
            )}
        </Table>
    )
}